import React from 'react';
import {User} from '../../graphql';
import {UserEditView} from './view';

interface UserEditContainerProps {
  user: User;
  updateUser: Function;
}

export const UserEditContainer = (props: UserEditContainerProps) => {
  return <UserEditView {...props} />;
};
